import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Flashlight icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Flashlight } from '@sravni/design-system-icons'
 *
 * <Flashlight />
 * ```
 */
var Flashlight = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Flashlight", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m10.806 2.5-6.848 9.167H10L9.194 17.5l6.848-9.167H10l.806-5.833Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Flashlight };
//# sourceMappingURL=Flashlight.js.map
